'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);


var _components = require('../../components');
var _RealtorPackageDetails = require('./Details/RealtorPackageDetails');var _RealtorPackageDetails2 = _interopRequireDefault(_RealtorPackageDetails);
var _PublisherPackageDetails = require('./Details/PublisherPackageDetails');var _PublisherPackageDetails2 = _interopRequireDefault(_PublisherPackageDetails);

var _constants = require('../../constants');
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _paymentCalculation = require('../../helpers/paymentCalculation');
var _packagesData = require('../../packagesData');

var _PackageItem = require('./PackageItem.scss');var styles = _interopRequireWildcard(_PackageItem);
var _realtorLanding = require('../../../static/icons/realtorLanding');var _realtorLanding2 = _interopRequireDefault(_realtorLanding);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var PackageItem = function (_Component) {_inherits(PackageItem, _Component);function PackageItem() {var _temp, _this, _ret;_classCallCheck(this, PackageItem);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPromoImage = function (highlight, topPromotion, autojump) {if (highlight && autojump) {
        return _realtorLanding2.default.highlight;
      }

      if (highlight) {
        return _realtorLanding2.default.highlight;
      }

      if (autojump) {
        return _realtorLanding2.default.autojump;
      }

      if (topPromotion) {
        return _realtorLanding2.default.top;
      }

      return '';
    }, _this.

    renderDiscount = function (discount) {return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.discount, discount > 10 ? styles.pink : styles.yellow) },
          discount + '% ' + _this.props.translate('discount')));}, _this.



    renderRealtorPackageDetails = function () {return (
        _react2.default.createElement(_RealtorPackageDetails2.default, {
          translate: _this.props.translate,
          isMobile: _this.props.isMobile,
          locale: _this.props.locale,
          packageData: _this.props.package,
          selectedPackage: _this.props.selectedPackage,
          changeSelectedPayment: _this.props.changeSelectedPayment }));}, _this.



    renderPublisherPackageDetails = function () {
      var type = (0, _get2.default)(_this.props, 'package.type');
      var selectedPeriod = (0, _get2.default)(_this.props, 'selectedPackage.period');
      var alternativePeriod = (0, _get2.default)(_this.props, 'selectedPackage.alternativePeriod');
      var currentPeriod = (0, _get2.default)(_this.props, 'package.period.' + selectedPeriod) ? selectedPeriod : alternativePeriod;
      var isRegularAd = type === _packagesData.packageTypes.REGULAR;
      var isTopAd = type === _packagesData.packageTypes.TOP;

      return !isRegularAd &&
      _react2.default.createElement(_PublisherPackageDetails2.default, {
        translate: _this.props.translate,
        packageType: type,
        selectedPeriod: currentPeriod,
        requiredMessage: isTopAd && _this.props.translate('topPromotionRequiredMessage') });


    }, _this.

    renderDetails = function () {return _this.props.isAgent ?
      _this.renderRealtorPackageDetails() :
      _this.renderPublisherPackageDetails();}, _this.

    renderTooltipMsg = function (withHighlight, isTopPromotion, withAutojump) {return withHighlight || isTopPromotion || withAutojump ?

      _react2.default.createElement('div', { className: styles.tooltipContent },
        _react2.default.createElement('img', { src: _this.getPromoImage(withHighlight, isTopPromotion, withAutojump), alt: '' })) :











      _react2.default.createElement('div', { className: styles.tooltipContent },
        _react2.default.createElement('img', { src: _constants.packageIcons.withoutHighlight, alt: '' }));}, _this.



    renderPrice = function (price) {var _cx;
      var beautifiedPrice = (0, _beautifyNumber2.default)((0, _clearNumber2.default)(price));
      var separator = _this.props.isAgent ? ' ' : ' / ';
      var monthKey = _this.props.isAgent ? 'perMonth' : 'month';
      var perMonth = _this.props.isMobile && !_this.props.isAgent ?
      '' :

      _react2.default.createElement('span', { className: (0, _classnames2.default)((_cx = {}, _cx[styles.perMonth] = !_this.props.isAgent, _cx)) },
        separator, _this.props.translate(monthKey));



      var realtorPackagePrice = _react2.default.createElement('span', { className: styles.priceTitle }, '\u20AA' + beautifiedPrice, perMonth);

      var publisherPackagePrice = beautifiedPrice === '0' ?
      _this.props.translate('freePrice') :
      _react2.default.createElement('span', null, '\u20AA' + beautifiedPrice);

      return _this.props.isAgent ? realtorPackagePrice : publisherPackagePrice;
    }, _this.

    renderRealtorTitle = function () {var
      properties = _this.props.package.properties;
      return {
        properties: _react2.default.createElement('span', { className: styles.boldText }, _this.props.translate('plan') + ' ' + properties) };

    }, _this.

    renderPublisherTitle = function () {var _this$props =
      _this.props,_this$props$package = _this$props.package,period = _this$props$package.period,type = _this$props$package.type,selectedPackage = _this$props.selectedPackage;var _ref =

      period[selectedPackage.period] ||
      period[selectedPackage.alternativePeriod] ||
      {},highlight = _ref.highlight,autojump = _ref.autojump,top_promotion = _ref.top_promotion;


      return {
        properties: _react2.default.createElement('span', { className: styles.boldText }, _this.props.translate(type + 'Ad')),
        highlight:
        _react2.default.createElement(_components.HighlightTitleForPublisherPackage, {
          haveHighlight: highlight,
          haveAutojump: autojump,
          haveTopPromotion: top_promotion,
          topPromotionLabel: '' + _this.props.translate('topPromotionLabel') }) };



    }, _this.

    renderTitle = function () {return _this.props.isAgent ? _this.renderRealtorTitle() : _this.renderPublisherTitle();}, _temp), _possibleConstructorReturn(_this, _ret);}PackageItem.prototype.

  render = function render() {var _this2 = this,_cx2;var _props =
    this.props,_props$package = _props.package,period = _props$package.period,id = _props$package.id,selectedPackage = _props.selectedPackage,isAgent = _props.isAgent,isMobile = _props.isMobile;
    var currentPeriod = period[selectedPackage.period] ? selectedPackage.period : selectedPackage.alternativePeriod;var _ref2 =
    period[currentPeriod] || {},price = _ref2.price,discount = _ref2.discount,highlight = _ref2.highlight,top_promotion = _ref2.top_promotion,autojump = _ref2.autojump;

    var prices = {
      month: this.renderPrice(price === 350 ? 352 : price), // really needs, principal crutch
      withDiscount: this.renderPrice((0, _paymentCalculation.calculatePriceWithDiscount)(this.props.package, currentPeriod)) };

    var checked = selectedPackage.checked === id;

    return (
      _react2.default.createElement(_components.OMRadioButtonItem, {
          className: this.props.className,
          element: this.renderTitle(),
          params: {
            name: 'package' + id,
            onChange: function onChange() {return _this2.props.changeSelectedPayment({ checked: id });},
            value: id,
            checked: checked,
            isMobile: isMobile,
            isAgent: isAgent },

          details: this.renderDetails(),
          parameters: !isAgent && {
            onMouseEnter: function onMouseEnter() {return _this2.props.handleMouseEnter(id);},
            onMouseLeave: function onMouseLeave() {return _this2.props.handleMouseLeave(id);} } },


        (isAgent && !checked || !isAgent) &&
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.pricePart, (_cx2 = {}, _cx2[styles.publisherPrice] = !isAgent, _cx2)) },
          _react2.default.createElement('div', { className: styles.discountWrapper },
            !!discount && this.renderDiscount(discount),

            _react2.default.createElement('div', { className: styles.priceWithDiscount, style: this.props.isAgent ? { position: 'static' } : {} },
              _react2.default.createElement('div', null, prices.withDiscount),
              !!discount &&
              _react2.default.createElement('div', { className: styles.clearPrice },
                prices.month)))),







        !this.props.isMobile && !isAgent &&
        _react2.default.createElement(_reactAddonsCssTransitionGroup2.default, {
            transitionName: 'package-tooltip',
            transitionAppear: true,
            transitionAppearTimeout: 300,
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300,
            onClick: function onClick(evt) {return evt.preventDefault();} },

          this.props.showTooltip &&
          _react2.default.createElement(_components.OMTooltip, {
            key: 'package-tooltip-' + id,
            msg: this.renderTooltipMsg(highlight, top_promotion, autojump),
            className: 'packageTooltip',
            onClose: this.props.handleCloseTooltip }))));






  };return PackageItem;}(_react.Component);exports.default = PackageItem;


PackageItem.propTypes = {
  package: _propTypes2.default.object,
  periods: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  changeSelectedPayment: _propTypes2.default.func.isRequired,
  selectedPackage: _propTypes2.default.object.isRequired,
  hasPhotos: _propTypes2.default.bool,
  showTooltip: _propTypes2.default.bool,
  handleMouseEnter: _propTypes2.default.func,
  handleMouseLeave: _propTypes2.default.func,
  handleCloseTooltip: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PackageItem/PackageItem.js
// module id = 1224
// module chunks = 0